import { Point, PriceComponent } from '@/types';
import { BuyOrSellLabel } from '../types/api/PriceComponent';
import { colors } from '../utils/colors';
import React from 'react';

export type PoolListItemProps = {
  pool: PriceComponent;
  point: Point;
  multiPoint?: boolean;
  onClick?: (pool: PriceComponent) => void;
};

const TYPE_COLOR_MAP: Record<string, string> = {
  [BuyOrSellLabel.BUY]: colors.elements.buyMarketColor,
  [BuyOrSellLabel.SELL]: colors.elements.sellMarketColor,
  [BuyOrSellLabel.BOTH]: colors.elements.bothMarketColor,
};

const TYPE_LABEL_MAP: Record<string, string> = {
  [BuyOrSellLabel.BUY]: 'Buy',
  [BuyOrSellLabel.SELL]: 'Sell',
  [BuyOrSellLabel.BOTH]: 'Buy & Sell',
};

export const PoolListItem: React.FC<PoolListItemProps> = ({
  pool,
  multiPoint = false,
  point,
  onClick,
}) => {
  return (
    <div key={pool.id} role="button" onClick={() => onClick?.(pool)}>
      <div>
        <b>#{pool.id}</b> {pool.description}
        {multiPoint && (
          <p
            className="text-muted py-0 my-0 d-flex align-items-center"
            style={{ fontSize: '14px' }}
          >
            at {point.name}
          </p>
        )}
      </div>
      <div className="d-flex gap-3">
        <span>
          {/* <ArrowDownIcon /> */}
          Receipt Zone: {point.receipt_zone_name}
        </span>
        <span>
          {/* <ArrowUpIcon /> */}
          Delivery Zone: {point.delivery_zone_name}
        </span>
      </div>
      <div className="d-flex gap-3 mt-3">
        <span>{point.tsp_name}</span>
      </div>
      <div className="text-end d-flex justify-content-end gap-3 mt-2">
        <span style={{ color: TYPE_COLOR_MAP[pool.buy_sell.toLowerCase()] }}>
          {TYPE_LABEL_MAP[pool.buy_sell.toLowerCase()]}
        </span>
      </div>
      <hr />
    </div>
  );
};
